import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getAllPdfLogs } from '../../../dataSource/PDFSource';

const MenuAnalytics = ({restaurant}) => {

  const [data, setData] = useState([]);

   const [timeFrame, setTimeFrame] = useState('day');

  useEffect(() => {
    async function fetchData() {
      const result = await getAllPdfLogs(restaurant);
      if (result) {
        const aggregatedData = aggregateData(result, timeFrame);
        setData(aggregatedData);
      }
    }
    fetchData();
  }, [timeFrame]);

  const aggregateData = (logs, timeFrame) => {
    const now = new Date();
    const aggregatedData = logs.reduce((acc, log) => {
      const orderDate = new Date(log.timestamp);
      orderDate.setHours(orderDate.getHours() + 1);
      let key;
  
      switch (timeFrame) {
        case 'year':
          key = orderDate.getFullYear();
          break;
  
        case 'month':
          if (orderDate.getFullYear() === now.getFullYear()) {
            key = orderDate.toLocaleString('default', { month: 'long' });
          }
          break;
  
        case 'week':
          if (orderDate.getFullYear() === now.getFullYear()) {
            const weekNumber = getWeekNumber(orderDate);
            key = `Week ${weekNumber}`;
          }
          break;
  
        case 'day':
          if (orderDate.getFullYear() === now.getFullYear() && orderDate.getMonth() === now.getMonth()) {
            key = `${orderDate.getDate()} ${orderDate.toLocaleString('default', { month: 'long' })}`;
          }
          break;
  
        case 'hour':
          // Group by hour (ignore minutes and seconds)
          key = `${orderDate.getHours()}:00`;
          break;
  
        case 'minute':
          // Group by minute (ignore hours, seconds)
          key = `${orderDate.getHours()}:${String(orderDate.getMinutes()).padStart(2, '0')}`;
          break;
  
        case '5min':
          // Group by 5-minute intervals
          key = `${orderDate.getHours()}:${Math.floor(orderDate.getMinutes() / 5) * 5}`;
          break;
  
        case '15min':
          // Group by 15-minute intervals
          key = `${orderDate.getHours()}:${Math.floor(orderDate.getMinutes() / 15) * 15}`;
          break;
  
        case '30min':
          // Group by 30-minute intervals
          key = `${orderDate.getHours()}:${Math.floor(orderDate.getMinutes() / 30) * 30}`;
          break;
  
        default:
          key = 'All Time';
      }
  
      // Add log data to the aggregation if a key exists
      if (key) {
        if (!acc[key]) {
          acc[key] = { name: key, logs: 0 };
        }
        acc[key].logs += 1;
      }
  
      return acc;
    }, {});
  
    return Object.values(aggregatedData);
  };
  

  const getWeekNumber = (date) => {
    const start = new Date(date.getFullYear(), 0, 1);
    const diff = (date - start + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60000)) / 86400000;
    const weekNumber = Math.floor((diff + start.getDay() + 6) / 7);
    return weekNumber;
  };

  return (
    <div className="order-analytics lightBorder">

      <h2>Menu Opgehaald {restaurant}</h2>
      <div className="filter-container lightBorder">
        <label htmlFor="timeFrame">Tijdframe:</label>
        <select id="timeFrame" value={timeFrame} onChange={(e) => setTimeFrame(e.target.value)}>
            <option value="all">Alles</option>
            <option value="year">Jaar</option>
            <option value="month">Maand</option>
            <option value="week">Week</option>
            <option value="day">Dag</option>
            <option value="hour">Uur</option>
            <option value="30min">30 Minuten</option>
            <option value="15min">15 Minuten</option>
            <option value="5min">5 Minuten</option>            
            <option value="minute">Minuut</option>
        </select>
        </div>

      {/* <BarChart
        width={800}
        height={400}
        data={data}
        margin={{
          top: 20, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="logs" fill="#82ca9d" />
      </BarChart> */}
       <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 25, right: 0, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="logs" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MenuAnalytics;
